import { encodeBytesToBase64, BASE64_URL_SAFE } from "./base64ArrayBuffer";

export const randomBytes = (bytes: number) =>
  crypto.getRandomValues(new Uint8Array(bytes));

export const randomId = (entropy: number = 128) =>
  encodeBytesToBase64(randomBytes(Math.ceil(entropy / 8)), BASE64_URL_SAFE);
